import { ArticleHeading, Section } from '../content'
import P from '@bootstrap-styled/v4/lib/P'
import Media from '@bootstrap-styled/v4/lib/Media'
import Img from '@bootstrap-styled/v4/lib/Img'
import Stars from '../reviews/Stars'
import React from 'react'
import styled from 'styled-components'
import moment from 'moment-timezone'

const Review = styled(Media)`
  &.media {
    margin-top: 18px;
    margin-bottom: 36px;
  }
  .media-body {
    padding-bottom: 36px;
    border-bottom: 1px solid #eaeaea;
  }
  .media-heading {
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .review-title {
    font-weight: normal;
    margin-bottom: 0;
    .name {
      ${(props) => `
         color: ${props.theme['$headings-color']};
      `};
      font-weight: 500;
    }
  }
`

function BlockReviews ({ reviewData }) {
  return (
    <Section>
      <ArticleHeading>Ratings & Reviews</ArticleHeading>
      <div className={'mb-5'}>
        <P>We currently have 56 ratings & reviews with an average star rating of 4.96</P>
      </div>
      {reviewData.items.map((r, i) => (
        <Review key={`review-${i}`}>
          <Media body>
            <Media heading tag={'div'}>
              <Img
                alt={r.patientName}
                className={'rounded-circle mr-3'}
                src={`https://ui-avatars.com/api/?name=${r.patientName.split(' ')[0]}+${r.patientName.split(' ')[1]}&size=52&background=152231&color=ffffff`}
              />
              <div>
                <p className={'review-title'}><span className={'name'}>{r.patientName}</span> &middot; <small>{moment(r.createdAt).format('MMMM YYYY')}</small></p>
                <Stars value={r.ratingValue}/>
              </div>
            </Media>
            {r.content}
          </Media>
        </Review>
      ))}
    </Section>
  )
}

export default BlockReviews
